import React from 'react';
import { Flex, Box, Divider } from '@chakra-ui/react';
import BELangCurrencySelect from '@view/components/Popovers/LangCurrencySelect';

const DemoLangCurrencySelect = () => {
  return (
    <Box>
      <h2>Language/Currency Select</h2>
      <Divider m={2} />
      <Flex align={'center'} gap={2}>
        <BELangCurrencySelect size={'md'} />
      </Flex>
    </Box>
  );
};

export default DemoLangCurrencySelect;
